import React from 'react'

import InfoHero from '../components/Info/Hero'
import { sections } from '../constants/onlineTuition'

const Hero = () => (
  <InfoHero
    sectionId={sections.description}
    title="Online Tuition"
    subtitle="Enjoy high quality lessons from the comfort of your homes!"
  />
)

export default Hero
